import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, setToken, formatError } from "../lib/api";

const Login = () => {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setToken(data.token);
      toast.success("Welcome back");
      nav("/admin");
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail) || "Login failed.");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[#0B1F3A] relative overflow-hidden">
      <div className="absolute inset-0 tech-grid-dark opacity-40" /><div className="grain" />
      <form onSubmit={submit} className="relative bg-white rounded-lg p-8 w-full max-w-md mx-4" data-testid="login-form">
        <p className="text-xs uppercase tracking-[0.22em] text-[#1261A0] font-semibold">Airanet CMS</p>
        <h1 className="mt-2 font-head font-extrabold text-2xl text-[#0B1F3A]">Admin Sign In</h1>
        <label className="block mt-6"><span className="text-sm font-medium">Email</span>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" className="mt-1.5 w-full border border-[#E2E8F0] rounded-md px-3 py-2.5 focus:border-[#1EA7E1] outline-none" /></label>
        <label className="block mt-4"><span className="text-sm font-medium">Password</span>
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" className="mt-1.5 w-full border border-[#E2E8F0] rounded-md px-3 py-2.5 focus:border-[#1EA7E1] outline-none" /></label>
        <button disabled={loading} data-testid="login-submit" className="mt-6 w-full bg-[#0B1F3A] text-white font-semibold py-3 rounded-md hover:bg-[#1261A0] disabled:opacity-60">{loading ? "Signing in…" : "Sign In"}</button>
      </form>
    </div>
  );
};

export default Login;
